import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { TrackingMapComponent } from '../../ui-kit/tracking-maps/tracking-map/tracking-map.component';
import { ExpansionMapComponent } from './expansion-map.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { SvgIconComponent } from '../../ui-kit';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    TrackingMapComponent,
    MatExpansionModule,
    TranslateModule.forChild({}),
    SvgIconComponent,
  ],
  exports: [ExpansionMapComponent],
  declarations: [ExpansionMapComponent],
})
export class ExpansionMapModule {}
